import Vue from 'vue'
import VueRouter from 'vue-router'
import Landing from '../views/Landing.vue';
import Insights from '../views/Insights.vue';
import QA from '../views/QA.vue';
import Impact from '../views/Impact.vue'
import Spotlight from '../views/Spotlight.vue';
import TuitionCalculator from '../views/TuitionCalculator.vue';
import VueFbCustomerChat from 'vue-fb-customer-chat'
Vue.use(VueFbCustomerChat, {
  page_id: "109400754254115", //  change 'null' to your Facebook Page ID,
  theme_color: '#800080', // theme color in HEX
  locale: 'en_US', // default 'en_US'
})
Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Landing",
    component: Landing,
  },
  {
    path: "/insights",
    name: "Insights",
    component: Insights,
  },
  {
    path: "/qa",
    name: "QA",
    component: QA,
  },
  {
    path: "/impact",
    name: "Impact",
    component: Impact,
  },
  {
    path: "/spotlight",
    name: "Spotlight",
    component: Spotlight,
  },
  {
    path: "/tuitioncalculator",
    name: "TuitionCalculator",
    component: TuitionCalculator,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
